import { render, staticRenderFns } from "./headerPage.vue?vue&type=template&id=56974b1a&scoped=true"
import script from "./headerPage.vue?vue&type=script&lang=js"
export * from "./headerPage.vue?vue&type=script&lang=js"
import style0 from "./headerPage.vue?vue&type=style&index=0&id=56974b1a&prod&scoped=true&lang=less"
import style1 from "./headerPage.vue?vue&type=style&index=1&id=56974b1a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56974b1a",
  null
  
)

export default component.exports